import { Extension } from "@tiptap/core";
import { CharacterCount } from "@tiptap/extension-character-count";
import { Dropcursor } from "@tiptap/extension-dropcursor";
import Focus from "@tiptap/extension-focus";
import { Gapcursor } from "@tiptap/extension-gapcursor";
import { HardBreak } from "@tiptap/extension-hard-break";
import { ListItem } from "@tiptap/extension-list-item";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Placeholder } from "@tiptap/extension-placeholder";
import { Text } from "@tiptap/extension-text";
import { TextStyle } from "@tiptap/extension-text-style";

import { Document } from "../extensions/Document";
import { Column, MultiColumn } from "../extensions/MultiColumn";
import { Selection } from "../extensions/Selection";
import { TextBubble } from "../extensions/TextBubble";
import { TrailingNode } from "../extensions/TrailingNode";

export const BaseKit =
	Extension.create(
		{
			name: "base-kit",

			addExtensions() {
				const extensions = [];

				if (this.options.document !== false) {
					extensions.push(Document.configure());
				}

				if (this.options.placeholder !== false) {
					extensions.push(
						Placeholder.configure({
							...this.options.placeholder
						})
					);
				}

				if (this.options.focus !== false) {
					extensions.push(
						Focus.configure({
							className: "focus",
							...this.options.focus
						})
					);
				}

				if (this.options.text !== false) {
					extensions.push(Text.configure());
				}
				if (this.options.textBubble !== false) {
					extensions.push(TextBubble.configure());
				}

				if (this.options.gapcursor !== false) {
					extensions.push(Gapcursor.configure());
				}

				if (this.options.dropcursor !== false) {
					extensions.push(
						Dropcursor.configure({
							...this.options.dropcursor,
							width: 2,
							class: "ProseMirror-dropcursor border-black"
						})
					);
				}

				if (this.options.characterCount !== false) {
					extensions.push(CharacterCount.configure(this.options.characterCount));
				}

				if (this.options.paragraph !== false) {
					extensions.push(Paragraph.configure(this.options.paragraph));
				}

				if (this.options.hardBreak !== false) {
					extensions.push(HardBreak.extend({
						addKeyboardShortcuts() {
							return {
								Enter: () => this.editor.commands.setHardBreak()
							}
						}
					}));
				}

				if (this.options.listItem !== false) {
					extensions.push(ListItem.configure(this.options.listItem));
				}

				if (this.options.textStyle !== false) {
					extensions.push(TextStyle.configure(this.options.textStyle));
				}

				if (this.options.trailingNode !== false) {
					extensions.push(TrailingNode.configure(this.options.trailingNode));
				}

				if (this.options.selection !== false) {
					extensions.push(Selection);
				}

				if (this.options.multiColumn !== false) {
					extensions.push(Column);
					extensions.push(MultiColumn);
				}

				return extensions;
			}
		});
